import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useCallback } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import { useFeatureFlag } from 'shared/feature-flags';
import Modal from 'ud-ui/components/modal';
import ApplicationsTeamScreen from '../components/applications-v2/applications-team-screen';
import ApplicationsTeamsScreen from '../components/applications-v2/applications-teams-screen';
import ChampionshipApplications from '../components/championship-teams/championship-applications';
import TeamPlayersPage from './team-players-page';

type ChampionshipApplicationsPageProps = {
  championshipId: number;
};

/**
 * Вкладка «Участники» соревнования — развилка двух флоу.
 *
 * Адреса у обоих одинаковые (`/championships/:id/applications[/:teamId]`), различается
 * только набор экранов: флаг `applicationsFlowV2` включает второй вариант тем, кто
 * зарегистрировался после даты отсечки, либо тем, кому его включили вручную (`?flow=v2`).
 * Значение по умолчанию — старый флоу.
 *
 * Список команд рендерится всегда, а `:teamId` — отдельным `<Routes>` рядом (не вместо):
 * когда он матчится, состав команды открывается модалкой поверх списка, который остаётся
 * смонтированным и виден за затемнением. Второй `<Routes>` матчится относительно текущего
 * роута, а не от корня, поэтому не зависит от того, где именно эта страница смонтирована.
 */
const ChampionshipApplicationsPage = ({ championshipId }: ChampionshipApplicationsPageProps) => {
  const navigate = useNavigate();
  const isFlowV2 = useFeatureFlag('applicationsFlowV2');

  const handleClose = useCallback(() => {
    navigate(Pages.CHAMPIONSHIPS.builders.edit(championshipId, ChampionshipEditTab.TEAMS));
  }, [championshipId, navigate]);

  return (
    <>
      {isFlowV2 ? (
        <ApplicationsTeamsScreen championshipId={championshipId} />
      ) : (
        <ChampionshipApplications championshipId={championshipId} />
      )}

      <Routes>
        <Route
          path=":teamId"
          element={
            <Modal show onClose={handleClose} width={1140} height={isFlowV2 ? undefined : 720}>
              {isFlowV2 ? <ApplicationsTeamScreen championshipId={championshipId} /> : <TeamPlayersPage />}
            </Modal>
          }
        />
      </Routes>
    </>
  );
};

export default ChampionshipApplicationsPage;
